(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keycap-home"] && !Shopify.designMode) return;
  try {
    
  const keycapTranslations = JSON.parse(document.querySelector('[data-keycap-translations]').textContent);
  const keycapCards = Array.from(document.querySelectorAll('.keycap-product-card'));
  const keycapFilterButtons = Array.from(document.querySelectorAll('[data-filter]'));
  const keycapCartDrawer = document.querySelector('[data-cart-drawer]');
  const keycapCartItems = document.querySelector('[data-cart-items]');
  const keycapCartEmpty = document.querySelector('[data-cart-empty]');
  const keycapCartTotal = document.querySelector('[data-cart-total]');
  const keycapDialog = document.querySelector('[data-product-dialog]');
  const keycapDialogImage = document.querySelector('[data-dialog-image]');
  const keycapDialogMaterial = document.querySelector('[data-dialog-material]');
  const keycapDialogTitle = document.querySelector('[data-dialog-title]');
  const keycapDialogPrice = document.querySelector('[data-dialog-price]');
  const keycapDialogDescription = document.querySelector('[data-dialog-description]');
  const keycapCart = new Map();
  let keycapActiveCard = null;
  function keycapOpenCart() { keycapCartDrawer.classList.add('is-open'); keycapCartDrawer.setAttribute('aria-hidden', 'false'); }
  function keycapCloseCart() { keycapCartDrawer.classList.remove('is-open'); keycapCartDrawer.setAttribute('aria-hidden', 'true'); }
  function keycapRenderCart() {
    const entries = Array.from(keycapCart.values());
    const total = entries.reduce((sum, item) => sum + item.quantity * Number(item.price.replace('$', '')), 0);
    keycapCartEmpty.style.display = entries.length ? 'none' : 'block';
    keycapCartTotal.textContent = `$${total}`;
    keycapCartItems.innerHTML = entries.map((item) => `<div class="keycap-cart-item"><img src="${item.image}" alt="${item.title}"><div><h3>${item.title}</h3><p>${item.quantity} x ${item.price}</p></div><button class="keycap-cart-remove" type="button" data-remove="${item.id}">${keycapTranslations.cartRemove}</button></div>`).join('');
  }
  function keycapAdd(card) {
    const id = card.dataset.title;
    const current = keycapCart.get(id);
    keycapCart.set(id, { id, title: card.dataset.title, price: card.dataset.price, image: card.dataset.image, quantity: current ? current.quantity + 1 : 1 });
    keycapRenderCart();
    keycapOpenCart();
  }
  function keycapOpenDialog(card) {
    keycapActiveCard = card;
    keycapDialogImage.src = card.dataset.image;
    keycapDialogImage.alt = card.dataset.title;
    keycapDialogMaterial.textContent = card.dataset.material;
    keycapDialogTitle.textContent = card.dataset.title;
    keycapDialogPrice.textContent = card.dataset.price;
    keycapDialogDescription.textContent = card.dataset.description;
    keycapDialog.showModal();
  }
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const filter = target.getAttribute('data-filter') || target.getAttribute('data-filter-button');
    if (filter) {
      keycapFilterButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.filter === filter));
      keycapCards.forEach((card) => { card.style.display = filter === 'all' || card.dataset.category === filter ? '' : 'none'; });
      document.querySelector('#shop').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const quick = target.closest('[data-quick-view]');
    if (quick) keycapOpenDialog(target.closest('.keycap-product-card'));
    const add = target.closest('[data-add]');
    if (add) keycapAdd(target.closest('.keycap-product-card'));
    const remove = target.getAttribute('data-remove');
    if (remove) { keycapCart.delete(remove); keycapRenderCart(); }
    if (target.matches('[data-cart-close]') || target === keycapCartDrawer) keycapCloseCart();
    if (target.matches('[data-dialog-close]')) keycapDialog.close();
    if (target.matches('[data-dialog-add]') && keycapActiveCard) { keycapDialog.close(); keycapAdd(keycapActiveCard); }
  });
  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.muted = true;
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(() => {});
  });
  keycapRenderCart();

  } catch(e) { console.error(e); }
})();
})();
